// En PDF
const is = require('../../plugins/helper/is')
const { initSW } = require('../../../plugins/push')
const Swal = require('../../plugins/sweet/Alert').default

const { defaultSwal, setAsLoaded } = require('./commonMethods')

const buttonSubmit = is.getNode('#load-sign-document #pills-sign-document-in-pdf #sign-document')
const validationMessagesDiv = is.getNode('#load-sign-document #pills-sign-document-in-pdf #validation-messages')

/**
 * @var null|Promise<any>
 */
let fileDocument = null

/**
 * @param {Array} messages
 */
const printErrorMessage = messages => {
  if (!is.node(validationMessagesDiv)) {
    return
  }
  if (!is.array(messages)) {
    return
  }

  const validationMessagesList = is.getNode('#load-sign-document #list-validation-messages')
  if (!is.node(validationMessagesList)) {
    return
  }

  validationMessagesList.innerHTML = ''
  validationMessagesDiv.style.display = 'block'

  messages.forEach(element => {
    const errorElement = document.createElement('li')
    const textErrorElement = document.createTextNode(element)
    errorElement.appendChild(textErrorElement)
    validationMessagesList.appendChild(errorElement)
  })
}

if (is.node(buttonSubmit) && is.node('#sign-document')) {
  const spinner = is.getNode('#spinner-sign-document')
  const inPDFInput = is.getNode('#sign-document')
  inPDFInput.onchange = async function () {
    fileDocument = await is.asyncHandleFileSelected(inPDFInput, null, spinner, buttonSubmit)
    if (is.file(fileDocument)) {
      setAsLoaded(inPDFInput, 'Se seleccionó y preparo el Documento correctamente.')
    }

    // Click enable
    const promiseNotify = initSW()
    if (!is.checkVariable(promiseNotify)) {
      return buttonSubmitEvent(inPDFInput, null)
    }

    return promiseNotify.then(notify => {
      return buttonSubmitEvent(inPDFInput, notify)
    })
  }

  // Listeners
  Swal.handleOn('success-send-data-in-pdf', function (e) {
    const { params } = e
    const Toast = Swal.mixin(defaultSwal)
    let message = 'Datos enviados correctamente.'
    if (is.checkVariable(params) && is.checkVariable(params.data) && is.checkVariable(params.data.success)) {
      message = params.data.success
    }
    Toast.fire({
      icon: 'success',
      title: message,
    })
    params.trigger.innerHTML = is.getHasAttribute(params.trigger, 'text-submit') ? is.getAttributeValue(params.trigger, 'text-submit') : 'Aceptar'
    is.waitInAWhile(defaultSwal.timer).then(() => {
      params.trigger.disabled = false
      if (is.checkVariable(params.data) && params.data.redirect) {
        window.location.href = params.data.redirect
      }
    })
  })
  Swal.handleOn('error-send-data-in-pdf', function (e) {
    const { params } = e
    is.captureException(params.error)

    const Toast = Swal.mixin(defaultSwal)
    Toast.fire({
      icon: 'error',
      title: 'Error al enviar los datos.',
    })
    if (
      params &&
      params.error &&
      params.error.response &&
      params.error.response.data &&
      params.error.response.data.errors
    ) {
      printErrorMessage(is.arrayFrom(params.error.response.data.errors))
      validationMessagesDiv.scrollIntoView()
    }
    params.trigger.disabled = false
    params.trigger.innerHTML = is.getHasAttribute(params.trigger, 'text-submit') ? is.getAttributeValue(params.trigger, 'text-submit') : 'Aceptar'
  })
}

/**
 * @param {HTMLElement} trigger
 * @param {Object|null} notify
 * @return {Promise}
 */
const buttonSubmitEvent = (trigger, notify) => {
  const form = document.getElementById('form-sign-document')
  const formData = is.cleanData(new FormData(form), ['sign-document'])
  if (is.file(fileDocument)) {
    formData.append('document', fileDocument)
  }
  if (is.checkVariable(notify)) {
    formData.append('push_subscription', JSON.stringify(notify))
  }

  const uri = is.getUniqueAttribute(form, 'action')
  const promise = Swal.axiosPost(formData, uri)
  promise.then(response => {
    Swal.handleResult(true, { data: response.data ?? null, trigger }, 'success-send-data-in-pdf')

    return response
  }).catch(error => {
    Swal.handleResult(false, { error, trigger }, 'error-send-data-in-pdf')

    return error
  })

  return promise
}
